import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component_SL_Button, Component_SL_Text } from '@app/styles/skeleton-loaders';
import { LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_AdvisorSL_FeedItem.scss';
export const Component_AdvisorSL_FeedItem = () => {
    return _jsxs(LL_H_C, { className: 'c-asl-feed-item', children: [_jsxs(LL_V_L, { className: 'c-asl-recap-item__header', children: [_jsx(Component_SL_Text, { variant: 'bold', height: 14, width: 'random' }), _jsx(Component_SL_Text, { variant: 'light', height: 14, width: 'random' })] }), _jsx(Component_SL_Button, { height: 24, width: 70 })] });
};
//# sourceMappingURL=Component_AdvisorSL_FeedItem.js.map